export default function Vision() {
  return (
    <section className="bg-bg">
      <div className="container-x py-14 md:py-18">
        <div className="grid gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <h2 className="text-2xl font-semibold tracking-tight md:text-3xl">What we set out to build</h2>
            <p className="mt-3 text-white/65">
              Startups are not about writing ideals. They are about repeatedly turning ideals into shipped facts.
              We want to make the hardest part of multi-chain experiences—payments, settlement, fees, supplementation,
              explainability, and auditability—into composable infrastructure.
            </p>
          </div>
          <div className="md:col-span-7">
            <div className="grid gap-4 md:grid-cols-2">
              <Feature
                title="Turn promises into receipts"
                desc="Every settlement yields an auditable receipt: transactions, actual output, supplement, and latency."
                accent="primary"
              />
              <Feature
                title="Lower costs via negotiation"
                desc="Replace blind overpaying with constrained negotiation: better fees and routes within hard guardrails."
                accent="secondary"
              />
              <Feature
                title="Compatible with third-party x402"
                desc="No private fields required. Normalize 402 challenges into a standard PaymentRequirement."
                accent="primary"
              />
              <Feature
                title="Observable and reversible execution"
                desc="Every step has state, evidence, and guardrails. Timeouts and refund paths stay explainable."
                accent="secondary"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

function Feature(props: { title: string; desc: string; accent: 'primary' | 'secondary' }) {
  const glow = props.accent === 'primary' ? 'shadow-glow' : 'shadow-glow2'
  const dot = props.accent === 'primary' ? 'bg-primary' : 'bg-secondary'
  return (
    <div className={`rounded-2xl border border-white/10 bg-surface/70 p-6 backdrop-blur ${glow}`}>
      <div className="flex items-center gap-2 text-sm font-semibold text-white/90">
        <span className={`h-2 w-2 rounded-full ${dot}`} />
        {props.title}
      </div>
      <div className="mt-2 text-sm leading-relaxed text-white/60">{props.desc}</div>
    </div>
  )
}
